// eslint-disable-next-line import/no-unresolved
module.exports = require('./build/OutsideClickHandler');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-outside-click-handler/index.js
// module id = 331
// module chunks = 0